import { render, staticRenderFns } from "./productionOrders.vue?vue&type=template&id=b5c8f05c"
import script from "./productionOrders.vue?vue&type=script&lang=js"
export * from "./productionOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports